module.exports = __webpack_public_path__ + "img/icon-2-1.ad1ddce8.png";